import { render, staticRenderFns } from "./StopRepair.vue?vue&type=template&id=45f89e0a"
import script from "./StopRepair.vue?vue&type=script&lang=js"
export * from "./StopRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports